import { render, staticRenderFns } from "./IButton.vue?vue&type=template&id=5883b52c&scoped=true&"
import script from "./IButton.vue?vue&type=script&lang=ts&"
export * from "./IButton.vue?vue&type=script&lang=ts&"
import style0 from "./IButton.vue?vue&type=style&index=0&id=5883b52c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5883b52c",
  null
  
)

export default component.exports